import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getReimbursementSummary} from '../../shared/repositories';
import {updateIsInitialLoad} from './is-initial-load';

export const readReimbursementSummary = params =>
    async dispatch => {

        if (params.postingDateFrom <= params.postingDateTo) {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                const payload = await getReimbursementSummary(params);

                dispatch({
                    payload,
                    type: actions.READ_REIMBURSEMENT_SUMMARY_SUCCESS
                });

                updateIsInitialLoad(false)(dispatch);

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        }

    };



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/action-creators/reimbursement-summary.js